module.exports = __webpack_public_path__ + "media/day/200-bb4c8c66.svg";